export const CRASHPAD = 'Crashpad'
export const ENTIRE_PLACE = 'Entire Place'
export const COLD_BED = 'Cold bed'
export const HOT_BED = 'Hot bed'

export const SUBSCRIPTION_ADVANTAGES = [
    {
      title: "Unlimited Bookings, Zero Fees",
      description: "No commissions, keep 100% of your earnings."
    },
    {
      title: "Flexible Listing Control",
      description: "Edit, pause, or activate listings anytime."
    },
    {
      title: "Smart Calendar & Bed Control",
      description: "Your availability updates automatically with bookings, and you can block beds manually."
    },
    {
      title: "Unlimited Messaging",
      description: "Communicate directly with crew members anytime."
    },
    {
      title: "Fast, Secure Payments",
      description: "Get paid immediately after every night your guests stay."
    },
    {
      title: "Unlimited Properties",
      description: "List one crashpad or multiple — it's all included."
    },
    {
      title: "Host Dashboard",
      description: "View all your reservations in one place for easy tracking and management."
    },
    {
      title: "Dispute Support",
      description: "We assist in resolving booking and deposit issues, giving you guidance and support when disputes arise."
    },
    {
      title: "Autopay for Cold Beds",
      description: "Enjoy reliable, stress-free income with automatic monthly payments from long-term crew stays."
    }
  ];